import { useMemo } from 'react'
import { StatePlayer } from 'player'
import { TaskOperations } from '../../../../types'
import {
  ChannelSettings,
  UsePersistedSettings
} from '../../../../hooks/player/use-persisted-channel-settings'
import { usePitchInitialState } from '../common/use-pitch-initial-state'

interface UseInitialStateProps {
  mainOperations: TaskOperations[]
  persistedSettings: UsePersistedSettings
}

const defaultMetronome: ChannelSettings[] = [
  'metronome_half',
  'metronome',
  'metronome_double'
].map((id) => {
  return {
    id,
    isMuted: true,
    isSolo: false,
    pan: 0,
    volume: 0.75
  }
})

export const useInitialState = ({
  mainOperations,
  persistedSettings
}: UseInitialStateProps): StatePlayer => {
  const { onGetSettings } = persistedSettings
  const preset = useMemo(() => onGetSettings(true), [onGetSettings])
  const pitchShiftCents = usePitchInitialState({ mainOperations, preset })

  return useMemo(() => {
    const channels = preset?.channels || []
    return {
      channels:
        channels?.filter(({ id }) => id.includes('metronome'))?.length === 3
          ? channels
          : [...channels, ...defaultMetronome],
      isRepeating: preset?.general?.isRepeating,
      typeChords: preset?.general?.typeChords,
      masterVolume: preset?.general?.masterVolume,
      pitchShiftCents,
      playbackRate: preset?.general?.playbackRate,
      loop: preset?.general?.loop,
      panels: preset?.panels,
      countIn: preset?.general?.countIn
    }
  }, [
    pitchShiftCents,
    preset?.channels,
    preset?.general?.typeChords,
    preset?.general?.countIn,
    preset?.general?.isRepeating,
    preset?.general?.loop,
    preset?.general?.masterVolume,
    preset?.general?.playbackRate,
    preset?.panels
  ])
}
